export enum ZDocumentType {
  MODELE_FACTURE = 'MODELE_FACTURE',
  MODELE_RELANCE = 'MODELE_RELANCE',
  MODELE_DOCUMENT = 'MODELE_DOCUMENT',
  AUTRE = 'AUTRE',
}

export class DocumentModel {
  Id: number;
  Nom: string;
  Type: ZDocumentType;
  ModeleId: number;
  DriveId: string;
  CollaborateurId: number;
  DossierId: number;
  NomDossier: string;
  DateCreation: Date;
}
